import React, { createContext, useState, useContext } from 'react'
/**
 *  ===============================
 *      SAFETY CHECK CONTEXT
 *  ===============================
 */
const PopupContext = createContext()

export const ProvideSafetyCheck = ({ children }) => {
  const [show, setShow] = useState(false)
  const [notification, setNotification] = useState(null)

  /* Show/Hide popup handlers */
  const displayPopup = (notificationId) => {
    setNotification(notificationId)
    setShow(true)
  }
  const hidePopup = () => {
    setNotification(null)
    setShow(false)
  }

  return (
    <PopupContext.Provider value={[displayPopup, hidePopup, show, notification]}>
      {
        children
      }
    </PopupContext.Provider>
  )
}

export const useSafetyCheckPopup = () => useContext(PopupContext)
